import { useState, type FormEvent } from 'react';
import { supabase } from '../../lib/supabase.js';

export function GymRequestForm() {
  const [gymName, setGymName] = useState('');
  const [email, setEmail] = useState('');
  const [city, setCity] = useState('');
  const [notes, setNotes] = useState('');
  const [err, setErr] = useState<string | null>(null);
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);

  async function submit(e: FormEvent) {
    e.preventDefault();
    setErr(null);
    setBusy(true);
    const { error } = await supabase.from('gym_requests').insert({
      gym_name: gymName,
      contact_email: email,
      city,
      notes,
    });
    setBusy(false);
    if (error) setErr(error.message);
    else setSent(true);
  }

  if (sent) {
    return (
      <div className="card">
        <h3 style={{ marginTop: 0 }}>Thanks! 🎉</h3>
        <p style={{ color: 'var(--fg-dim)' }}>We'll reach out within a few days.</p>
      </div>
    );
  }

  return (
    <form onSubmit={submit} className="card stack">
      <h3 style={{ marginTop: 0 }}>Request gym integration</h3>
      <label>Gym name
        <input value={gymName} onChange={(e) => setGymName(e.target.value)} required />
      </label>
      <label>Contact email
        <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
      </label>
      <label>City (optional)
        <input value={city} onChange={(e) => setCity(e.target.value)} />
      </label>
      <label>Notes (optional)
        <textarea value={notes} onChange={(e) => setNotes(e.target.value)} rows={3} />
      </label>
      {err && <div className="auth-error inline">{err}</div>}
      <button type="submit" disabled={busy}>{busy ? 'Sending…' : 'Send request'}</button>
    </form>
  );
}
